import { getTranslation } from "@/features/questionnaire/utils";
import { Option, Select } from "@repo/skapa";
import { useSettings } from "@repo/ui";

import { type QuestionsProps } from "../types";

export const DropdownQuestion = ({
  answer,
  onAnswerIdAnswered,
  question,
}: QuestionsProps) => {
  const { language } = useSettings();

  if (!question?.answers) {
    return null;
  }
  const selectedAnswerId = answer?.answerIds || undefined;

  return (
    <Select
      id="questionnaire-select"
      label=""
      value={selectedAnswerId?.[0]}
      onChange={(e) => {
        onAnswerIdAnswered?.(e.target.value ? [e.target.value] : []);
      }}
    >
      {question.answers.map((option) => (
        <Option
          key={option.answer_id_key}
          value={option.answer_id_key}
          name={getTranslation(
            option.answer_translation ?? [],
            language,
            option.answer_name
          )}
        />
      ))}
    </Select>
  );
};
